import * as React from 'react';
import { Tooltip as AntdTooltip } from 'antd';
import { TooltipPropsWithTitle as AntdTooltipProps } from 'antd/lib/tooltip';
import { AppContext } from '@/utils/appProvider';
import classnames from 'classnames';
import './index.less';

export interface TooltipProps extends AntdTooltipProps {
  className?: string;
  disable?: boolean;
}
const Tooltip: React.FC<TooltipProps> = (props) => {
  const { children, className } = props;
  const { prefixCls } = React.useContext(AppContext);

  return props?.disable || isMobile || isPad ? (
    <>{children}</>
  ) : (
    <AntdTooltip {...props} overlayClassName={classnames(`${prefixCls}-tooltip`, className)}>
      {children}
    </AntdTooltip>
  );
};

export default Tooltip;
